import { render, staticRenderFns } from "./Posted.vue?vue&type=template&id=ca583dc8&"
import script from "./Posted.vue?vue&type=script&lang=js&"
export * from "./Posted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports